module.exports = __webpack_public_path__ + "app-static/img/customer_b.cf1c9e63.png";